var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#272835;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6-Profile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_6-Profile",
    "data-name": "6-Profile"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,0A32,32,0,1,0,64,32,32,32,0,0,0,32,0Zm0,62a29.88,29.88,0,0,1-20.37-8H52.37A29.88,29.88,0,0,1,32,62ZM29.82,21h4.36A3.55,3.55,0,0,0,37,22.91V24c0,2.77-1.31,6-5,6s-5-3.23-5-6V22.91A3.55,3.55,0,0,0,29.82,21ZM27,20.86V16.47A8.31,8.31,0,0,1,32,15a8.31,8.31,0,0,1,5,1.47v4.39c-.5-.13-1-.38-1-.86a1,1,0,0,0-1-1H29a1,1,0,0,0-1,1C28,20.47,27.5,20.72,27,20.86Zm7.84,11.89L32,35.59l-2.84-2.84.38-1.19a7,7,0,0,0,4.9,0ZM31,37.41V41h2V37.41l3.25-3.25,6,2.61L43,38.24V52H40V47H38v5H26V47H24v5H21V38.24l.73-1.46,6-2.61ZM54.34,52H45V38a1,1,0,0,0-.11-.45l-1-2a1,1,0,0,0-.5-.47l-6.63-2.87-.54-1.67A8.2,8.2,0,0,0,39,24V16a1,1,0,0,0-.29-.71A9.73,9.73,0,0,0,32,13a9.73,9.73,0,0,0-6.71,2.29A1,1,0,0,0,25,16v8a8.2,8.2,0,0,0,2.77,6.54l-.54,1.67L20.6,35.08a1,1,0,0,0-.5.47l-1,2A1,1,0,0,0,19,38V52H9.66a30,30,0,1,1,44.67,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57,31A25,25,0,0,0,7,31H9a23,23,0,0,1,46,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7,
    y: 33,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55,
    y: 33,
    width: 2,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersvg);
export default __webpack_public_path__ + "static/media/usersvg.4f903b6f669fb73eeced07944ff5a714.svg";
export { ForwardRef as ReactComponent };